import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../common';
import { keyframes } from '@emotion/react';

export const PageNotFound = () => {
  const navigate = useNavigate();

  const gradientShift = keyframes`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  `;

  const float = keyframes`
    0% { transform: translateY(0); }
    50% { transform: translateY(-4px); }
    100% { transform: translateY(0); }
  `;
  const fadeUp = keyframes`
    0% { opacity: 0; transform: translateY(8px); }
    100% { opacity: 1; transform: translateY(0); }
  `;

  return (
    <Box
      sx={{
        height: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        gap: 2,
        p: 2,
        backgroundColor: 'white',
        minHeight: '91vh',
      }}
    >
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        sx={{
          mt: 2,
          fontWeight: 700,
          background: 'linear-gradient(90deg, #5e894f, #7ab365ff, #a9f38dff)',
          backgroundSize: '200% 200%',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          animation: `${gradientShift} 8s ease infinite`,
          letterSpacing: 4,
          fontSize: 84,
        }}
      >
        404
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
        <ErrorOutlineIcon
          sx={{
            fontSize: 44,
            color: 'primary.main',
            animation: `${float} 1.5s ease-in-out`,
          }}
        />
        <Typography variant="h6" color="textSecondary" gutterBottom sx={{ mt: 1, fontSize: 34 }}>
          Página no encontrada
        </Typography>
        <ErrorOutlineIcon
          sx={{
            fontSize: 44,
            color: 'primary.main',
            animation: `${float} 1.5s ease-in-out`,
          }}
        />
      </Box>

      <Typography variant="body1" sx={{ maxWidth: 560, fontSize: 18 }}>
        La página que estás buscando no existe o fue removida. Podés volver al inicio para seguir
        navegando.
      </Typography>
      <CustomButton
        variant="base"
        color="primary"
        onClick={() => navigate('/home')}
        sx={{
          mt: 2,
          transition: 'transform 180ms ease, box-shadow 180ms ease',
          '&:hover': { transform: 'translateY(-2px) scale(1.02)', boxShadow: 3 },
        }}
      >
        Ir al inicio
      </CustomButton>

      {/* subtle entrance animation for the whole box content */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
          animation: `${fadeUp} 700ms ease 1`,
          opacity: 0,
        }}
      />
    </Box>
  );
};
